<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="核销类型筛选"
          v-model="searchCondition.verifyType"
          style="width: 200px"
          filterable
        >
          <el-option label="订单发货" value="order"></el-option>
          <el-option label="预约活动" value="subscribe"></el-option>
          <el-option label="奖品兑换" value="game"></el-option>
          <el-option label="优惠券" value="coupon"></el-option>
          <el-option label="线下抽奖" value="offlineDraw"></el-option>
          <el-option label="储值卡" value="prepay"></el-option>
          <el-option label="兑换券" value="deductionVoucher"></el-option>
          <el-option label="服务项目" value="serviceProject"></el-option>
        </el-select>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择核销时间段筛选"
          end-placeholder="请选择核销时间段筛选"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.keyWords"
          size="small"
          placeholder="请输入"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width:100px"
            v-model="searchCondition.queryType"
          >
            <el-option label="核销人" value="verifyOperator"></el-option>
            <el-option label="核销码" value="verifyCode"></el-option>
            <el-option label="会员手机" value="memberMobile"></el-option>
            <el-option label="会员姓名" value="memberName"></el-option>
          </el-select>
        </el-input>
        <!-- <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入核销人/会员手机号/核销码"
          size="small"
          class="ipt mr10"
        ></el-input> -->
      </div>
      <div>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '核销记录')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员手机号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="会员姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="verifyType"
          label="核销类型"
          width="180px"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.verifyType === 'game'">
              奖品兑换
            </div>
            <div v-else-if="scope.row.verifyType === 'order'">
              订单发货
            </div>
            <div v-else-if="scope.row.verifyType === 'coupon'">
              优惠券
            </div>
            <div v-else-if="scope.row.verifyType === 'subscribe'">
              预约活动
            </div>
            <div v-else-if="scope.row.verifyType === 'offlineDraw'">
              线下抽奖
            </div>
            <div v-else-if="scope.row.verifyType === 'serviceProject'">
              服务项目
            </div>
            <div
              v-else-if="scope.row.verifyType === 'prepay'"
              :class="scope.row.verifyMoney ? 'flex item-center' : ''"
            >
              储值卡
              <div class="prepay ml10" v-if="scope.row.verifyMoney">
                <div class="before gray">
                  核销额：¥{{ scope.row.verifyMoney }}
                </div>
                <div class="before blue">
                  卡余额：¥{{ scope.row.cardBalance }}
                </div>
              </div>
            </div>
            <div v-else-if="scope.row.verifyType === 'deductionVoucher'">
              兑换券
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="verifyName"
          label="核销码名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="verifyCode"
          label="核销码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="verifyOperator"
          label="核销人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="departName"
          label="核销人机构"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="verifyTime"
          label="核销时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="verifyRemark"
          label="核销备注"
        ></el-table-column>
        <template slot="empty">
          <div class="empty" style="margin-top: 20px">
            <img class="img_no" src="../../assets/n001.jpg" alt="">
            <p class="empty_tex">请设置查询条件后查询</p>
          </div>
        </template>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      searchCondition: {
        queryType: "verifyOperator"
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      isOutputing: false
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // this.queryList();
  },
  methods: {
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.verifyStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.verifyEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryVerifyUsageRecordList",
        params
      );
      const { records, total } = result;

      this.list = records;
      this.total = total;
    },
    queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 999999
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.verifyStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.verifyEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryVerifyUsageRecordList", params);
    },
    search() {
      this.currentPage = 1;
      if(!this.searchCondition.verifyType && !this.searchCondition.createTimeArry && !this.searchCondition.keyWords){
        this.$confirm(
          "请输入搜索条件",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
      }else {
        this.queryList();
      }
      
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res.result.records;
            list.forEach(v => {
              if (v.verifyType === "game") {
                v.verifyType = "奖品兑换";
              } else if (v.verifyType === "order") {
                v.verifyType = "订单发货";
              } else if (v.verifyType === "coupon") {
                v.verifyType = "优惠券";
              } else if (v.verifyType === "subscribe") {
                v.verifyType = "预约活动";
              } else if (v.verifyType === "offlineDraw") {
                v.verifyType = "线下抽奖";
              } else if (v.verifyType === "prepay") {
                v.verifyType = "储值卡";
              } else if (v.verifyType === "deductionVoucher") {
                v.verifyType = "兑换券";
              }
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
.prepay {
  text-align: left;
  .before:before {
    display: inline-block;
    content: "●";
  }
}
</style>
